import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

document.title = process.env.REACT_APP_BRAND_LABEL || 'nexus. lead with evidence';

if (process.env.REACT_APP_DEMO_MODE === 'true') {
  const base = process.env.REACT_APP_BRAND_LABEL || 'nexus. lead with evidence';
  document.title = `Demo · ${base}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);